import { InputChangeEvent } from '@progress/kendo-react-inputs';
import { produce } from 'immer';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../../../common/widgets/Button';
import Icons from '../../../../../../../common/widgets/Icons';
import Input from '../../../../../../../common/widgets/Input';
import { EmployeeTemplateOptionModel } from '../../../../../models/EmployeeTemplateOptionModel';
import { resources } from '../../../../../resources/resources';

interface OptionPanelState {
  editMode: boolean;
  optionNewName: string;
}
interface OptionPanelProps {
  option: EmployeeTemplateOptionModel;
  saveOptionNewName: (optionId: number, optionName: string) => void;
  removeOption: (option: EmployeeTemplateOptionModel) => void;
}

export const OptionPanel = (props: OptionPanelProps) => {
  const { t: translate } = useTranslation();
  const { option, saveOptionNewName, removeOption } = props;
  const [state, setState] = useState({
    optionNewName: option?.name,
  } as OptionPanelState);

  return (
    <>
      <Icons.DashboardCircle />
      <Input
        readOnly={!state.editMode}
        value={state.optionNewName?.toUpperCase()}
        onChange={(e: InputChangeEvent) =>
          setState(
            produce(d => {
              d.optionNewName = e.value;
            }),
          )
        }
      />
      <div className="sorter-actions">
        {!state.editMode && (
          <Button
            className="btn btn-sm btn-template"
            onClick={() =>
              setState(
                produce(d => {
                  d.editMode = true;
                }),
              )
            }
            icon={<Icons.Edit />}
          >
            <span className="btn-text">
              {translate(resources.admin.fileImport.editTemplate.actions.edit)}
            </span>
          </Button>
        )}
        {state.editMode && (
          <Button
            className="btn btn-sm btn-template"
            onClick={() =>
              setState(
                produce(d => {
                  d.editMode = false;
                }),
              )
            }
            icon={<Icons.DeleteButton />}
          >
            <span className="btn-text">
              {translate(resources.admin.fileImport.actions.close)}
            </span>
          </Button>
        )}
        {state.editMode && (
          <Button
            className="btn btn-sm btn-template"
            onClick={() => {
              setState(
                produce(d => {
                  d.editMode = false;
                }),
              );
              saveOptionNewName(option.optionId, state.optionNewName);
            }}
            icon={<Icons.Check />}
          >
            <span className="btn-text">
              {translate(resources.admin.fileImport.actions.save)}
            </span>
          </Button>
        )}
        {!option?.isRequired && (
          <Button
            className="btn btn-sm btn-template"
            onClick={() => removeOption(option)}
            icon={<Icons.DeleteSmall />}
          >
            <span className="btn-text">
              {translate(
                resources.admin.fileImport.editTemplate.actions.delete,
              )}
            </span>
          </Button>
        )}
      </div>
    </>
  );
};
